import React from "react";
import Comingsoonpage from "../../../common/Comingsoon";

const Staff = () => {
  return (
    <div>
      <Comingsoonpage />
    </div>
  );
};

export default Staff;
